<form [formGroup]="natureForm" (ngSubmit)="addNature()">
  <div class="form-container">
    <div class="form-field">
      <label>{{'referentiels.list.natureProperties.codeHecate.header' | transloco }}<span class="required">*</span></label>
      <input pInputText type="number" formControlName="codeHecate" />
      <small class="p-error block">
        @if (natureForm.controls.codeHecate.errors?.required) {
          <p-message *ngIf="natureForm.controls['codeHecate'].invalid && natureForm.controls['codeHecate'].touched" severity="danger" text="Le code hecate est requis."></p-message>
        } @else if (natureForm.controls.codeHecate.errors?.maxlength) {
          <p-message *ngIf="natureForm.controls['codeHecate'].invalid && natureForm.controls['codeHecate'].touched" severity="danger" text="Le code hecate ne doit pas dépasser 10 caractères."></p-message>
        }
      </small>
    </div>

    <div class="form-field">
      <label>{{ 'referentiels.list.natureProperties.designation.header'| transloco }}<span class="required">*</span></label>
      <input pInputText formControlName="designation" />
      <small class="p-error block">
        <p-message *ngIf="natureForm.controls['designation'].invalid && natureForm.controls['designation'].touched" severity="danger" text="Le champ pour la désignation est requis."></p-message>
      </small>
    </div>
  </div>

  <div class="button-container">
    <p-button pRipple label="{{ 'button.cancel' | transloco }}" [rounded]="true" (onClick)="close(false)" />
    <p-button pRipple label="{{ 'button.validate' | transloco}}" [rounded]="true" type="submit" [disabled]="natureForm.invalid" />
  </div>

  <div *ngIf="submitting" class="loading-spinner">
    <p-progressSpinner [style]="{ width: '3rem', height: '3rem' }"></p-progressSpinner>
  </div>
</form>
<p-toast />
